import { render, staticRenderFns } from "./CvResume.vue?vue&type=template&id=20fc10ac&scoped=true"
import script from "./CvResume.vue?vue&type=script&lang=js"
export * from "./CvResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc10ac",
  null
  
)

export default component.exports